import { useState } from "react";
import { GoogleLoginButton as EtGoogleLoginButton } from "@ever-tutor/et-ui";
import { useNotificationStore } from "@/store/useNotificationStore";
import { authClient } from "@/lib/auth-client";
import { NotificationType } from "@/store/useNotificationStore";

interface GoogleLoginButtonProps {
  onSuccess?: () => void;
  onError?: (error: string) => void;
  mode?: "login" | "signup";
  label?: string;
}

const GoogleLoginButton = ({
  onSuccess,
  onError,
  mode = "login",
  label,
}: GoogleLoginButtonProps) => {
  const [isGoogleLoading, setIsGoogleLoading] = useState(false);
  const { showNotification } = useNotificationStore();

  const handleGoogleLogin = async () => {
    try {
      setIsGoogleLoading(true);
      await authClient.signIn.social({
        provider: "google",
        callbackURL: window.location.origin,
      });
      onSuccess?.();
    } catch (error: any) {
      console.error("Google login error:", error);
      const errorMessage = "Google login failed";
      showNotification(errorMessage, NotificationType.WARNING);
      onError?.(errorMessage);
      setIsGoogleLoading(false);
    }
  };

  return (
    <EtGoogleLoginButton
      onClick={handleGoogleLogin}
      isLoading={isGoogleLoading}
      mode={mode}
      label={label}
      aria-label={
        label ??
        (mode === "signup" ? "Sign up with Google" : "Sign in with Google")
      }
    />
  );
};

export default GoogleLoginButton;
